import { service } from '@ember/service';
import Component from '@glimmer/component';
import BasicDropdownWormhole from 'ember-basic-dropdown/components/basic-dropdown-wormhole';
import FlashMessage from 'ember-cli-flash/components/flash-message';
import NewVersionNotifier from 'ember-cli-new-version/components/new-version-notifier';

import HeaderBar from 'market-view-ui/components/application/header-bar';
import NotificationToast from 'market-view-ui/components/notification-toast';

import './application.scss';

export default class Application extends Component {
  @service session;
  @service flashMessages;

  <template>
    {{#if this.session.isAuthenticated}}
      <HeaderBar />
    {{/if}}

    <div class="flash-messages-container">
      {{#each this.flashMessages.queue as |flashItem|}}
        <FlashMessage @flash={{flashItem}} as |component content close|>
          <NotificationToast
            @close={{close}}
            @content={{content}}
            class="test-notification"
          />
        </FlashMessage>
      {{/each}}
    </div>

    <NewVersionNotifier
      @updateMessage="A new version of Market View is available! Reload for the latest updates. "
    />
    {{yield}}
    <BasicDropdownWormhole />
  </template>
}
